import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Link, navigate } from "@reach/router";
import SvgIcon from "@material-ui/core/SvgIcon";
import IconButton from "@material-ui/core/IconButton";
import SERVER_ADDRESS from "../../../config";
import { hasRole } from "../../../auth";
import {
  Title,
  Paragraph,
  SubTitle,
  DocImage,
  NavigateButton,
  DocPaper,
  DocLink
} from "../../DocCreater";

const useStyles = makeStyles(theme => ({
  grid: {
    flexGrow: 1
  },
  stepperBar: {
    marginTop: theme.spacing(4)
  },
  divider: {
    width: "100%",
    height: 1
  },
  paper: {
    width: "100%"
  },

  box: {
    display: "flex",
    "justify-content": "flex-end"
  }
}));

function PanoIntro(props) {
  const classes = useStyles();
  return (
    <DocPaper>
      <Title>实景学习模块</Title>
      <Paragraph>
        以下均为教师发布的真实建筑的实景虚拟教学资源案例，教学资源卡片包含资源的名称、所属的真实建筑、资源详细信息、资源分享、资源使用窗口，学生可在资源使用窗口中参照详细信息中的说明使用该教学资源。
      </Paragraph>
      <Paragraph>
        学生可通过实景学习模块，在真实建筑实物中进一步认知在清官式建筑中的各类构件的位置样式，与构件认知学习模块的理论部分相辅相成，同时为后续建筑现场踏查实习做好准备，虚实结合。
        <DocLink to="/learn/step/3">模块使用引导</DocLink>
      </Paragraph>
      <Paragraph>
        由于实景教学资源为多种类型的虚拟仿真资源，故请使用Google Chrome
        64位版本，以获得最佳体验效果（76.0.3809.132正式版本64 位），
        <DocLink
          to="
                https://www.google.cn/chrome/
                
                "
          newpage
        >
          下载Chrome
        </DocLink>
        。
      </Paragraph>
      {hasRole(["教师"]) && (
        <div className={classes.box}>
          <IconButton
            className={classes.add}
            color="secondary"
            onClick={() => {
              window.open(`${SERVER_ADDRESS}/api/panoramas/`);
            }}
            title="添加教学资源"
          >
            <SvgIcon>
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
            </SvgIcon>
          </IconButton>
        </div>
      )}
    </DocPaper>
  );
}

export default PanoIntro;
